import React from "react";
import "./Footer.css";
import { BsLinkedin, BsGithub } from "react-icons/bs";
const Footer = () => {
    return (
        <footer>
            <a href="#" className="footer__logo">
                uch2ha
            </a>
            <div className="footer__socials">
                <a href="https://www.linkedin.com/in/dmitry-sinyavskiy/">
                    <BsLinkedin />
                </a>
                <a href="https://github.com/uch2ha">
                    <BsGithub />
                </a>
            </div>
            <div className="footer__copyright">
                <small>
                    &copy; Copyright 2022 | All Rights are Reserved | Dmitry
                    Sinaysvkiy
                </small>
            </div>
        </footer>
    );
};

export default Footer;
